import createIcon from '../../createIcon';

/**
 * @component @name FlipCameraAndroid
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAxMkM5IDEzLjY2IDEwLjM0IDE1IDEyIDE1QzEzLjY2IDE1IDE1IDEzLjY2IDE1IDEyQzE1IDEwLjM0IDEzLjY2IDkgMTIgOUMxMC4zNCA5IDkgMTAuMzQgOSAxMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik04IDEwVjhINS4wOUM2LjQ3IDUuNjEgOS4wNSA0IDEyIDRDMTUuNzIgNCAxOC44NSA2LjU2IDE5Ljc0IDEwSDIxLjhDMjAuODcgNS40NCAxNi44NCAyIDEyIDJDOC43MyAyIDUuODIgMy41OCA0IDYuMDFWNEgyVjEwSDhaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTYgMTRWMTZIMTguOTFDMTcuNTMgMTguMzkgMTQuOTUgMjAgMTIgMjBDOC4yOCAyMCA1LjE1IDE3LjQ0IDQuMjYgMTRIMi4yQzMuMTMgMTguNTYgNy4xNiAyMiAxMiAyMkMxNS4yNyAyMiAxOC4xOCAyMC40MiAyMCAxNy45OVYyMEgyMlYxNEgxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FlipCameraAndroid = createIcon('FlipCameraAndroid', [
  [
    'path',
    {
      d: 'M9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9C10.34 9 9 10.34 9 12Z',
      key: 'r1z8sp',
    },
  ],
  [
    'path',
    {
      d: 'M8 10V8H5.09C6.47 5.61 9.05 4 12 4C15.72 4 18.85 6.56 19.74 10H21.8C20.87 5.44 16.84 2 12 2C8.73 2 5.82 3.58 4 6.01V4H2V10H8Z',
      key: 'q7qsd2',
    },
  ],
  [
    'path',
    {
      d: 'M16 14V16H18.91C17.53 18.39 14.95 20 12 20C8.28 20 5.15 17.44 4.26 14H2.2C3.13 18.56 7.16 22 12 22C15.27 22 18.18 20.42 20 17.99V20H22V14H16Z',
      key: 'ru62ur',
    },
  ],
]);

export default FlipCameraAndroid;
